import React from "react";
import SelectDropdown from "../../../components-react/SelectDropdown";
import { AlertIcon } from "../../../../images/icons/icons";

const FormSelect = ({ 
  icon: Icon, 
  label, 
  name, 
  options, 
  selectedOption, 
  setSelectedOption, 
  error, 
  disabled = false,
  required = false,
  onRef,
  className = ""
}) => {
  const hasValue = (value) => {
    if (typeof value === 'string') return value.trim() !== '';
    if (value instanceof File) return true;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object' && value !== null) return Object.keys(value).length > 0;
    return value !== null && value !== undefined && value !== '';
  };

  return (
    <div className={`staff-onboarding-form-group ${className}`}>
      <label className="staff-onboarding-form-label">
        {Icon && <Icon color="#6B7280" />}
        <span className="staff-onboarding-label-text">
          {label} {required && <span className="staff-onboarding-required">*</span>}
        </span>
      </label>
      
      <div className={`staff-onboarding-select-wrapper ${error ? "error" : ""} ${disabled ? "disabled" : ""} ${hasValue(selectedOption) ? 'has-value' : ''}`} ref={onRef}>
        <SelectDropdown
          options={options}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          name={label}
          isDisable={disabled}
        />
        {error && (
          <div className="staff-onboarding-error-message">
            <AlertIcon color="#EF4444" />
            <span>{error}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FormSelect;
